{
    "(save {highestYearlyDiscount}%)": "(uštedi {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} dana besplatno",
    "{amount} off": "{amount} popusta",
    "{amount} off for first {number} months.": "{amount} popusta za prvih {number} mjeseci.",
    "{amount} off for first {period}.": "{amount} popusta za prvo {period}.",
    "{amount} off forever.": "{amount} popusta zauvijek.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_few": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% popusta",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} više neće primati {newsletterName} newsletter.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} više neće primati Email kada neko odgovori na tvoje komentare.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} više neće primati ovaj newsletter.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} dana besplatno",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Račun",
    "Account details updated successfully": "",
    "Account settings": "Postavke računa",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Nakon isteka besplatnog probnog perioda, bit će ti naplaćena redovna cijena za plan koji si odabrao. Možeš otkazati članarinu prije toga.",
    "Already a member?": "Već si član?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Došlo je do neočekivane greška. Pokušaj ponovo ili <a>kontaktiraj podršku</a> ako se greška ponovi.",
    "Back": "Nazad",
    "Back to Log in": "Nazad na prijavu",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Black Friday",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Otkaži u bilo koje vrijeme.",
    "Cancel subscription": "Otkaži pretplatu",
    "Canceled": "",
    "Cancellation reason": "Razlog otkazivanja",
    "Change": "Promijeni",
    "Change plan": "",
    "Check spam & promotions folders": "Provjeri spam folder i posebne pod-foldere",
    "Check with your mail provider": "Provjeri s Email providerom",
    "Check your inbox to verify email update": "",
    "Choose": "Odaberi",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Odaberi drugi plan",
    "Choose a plan": "",
    "Choose a tier": "",
    "Choose your newsletters": "Odaberi svoje newslettere",
    "Click here to retry": "Pokušaj ponovo",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Zatvori",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Komentari",
    "Complimentary": "Besplatno",
    "Confirm": "Potvrdi",
    "Confirm cancellation": "Potvrdi otkazivanje",
    "Confirm subscription": "Potvrdi pretplatu",
    "Contact support": "Kontaktiraj podršku",
    "Continue": "Nastavi",
    "Continue subscription": "Produži pretplatu",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "Nije se moguće prijaviti. Link za prijavu je istekao.",
    "Could not update email! Invalid link.": "Nije moguće promijeniti Email! Pogrešan link.",
    "Create a new contact": "Dodaj novi kontakt",
    "Current plan": "Trenutni plan",
    "Delete account": "Izbriši račun",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Greška u namjeri? Provjeri svoje postavke <button>ovdje</button>.",
    "Don't have an account?": "Nemaš račun?",
    "Edit": "Uredi",
    "Email": "Email",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Email newsletter",
    "Email newsletter settings updated": "",
    "Email preferences": "Postavke Email-a",
    "Email preferences updated.": "",
    "Emails": "Email adrese",
    "Emails disabled": "Onemogućene Email adrese",
    "Ends {offerEndDate}": "Završava {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "Greška",
    "Expires {expiryDate}": "Ističe {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "Zauvijek",
    "Free Trial – Ends {trialEnd}": "Besplatni probni period – Ističe {trialEnd}",
    "From": "",
    "Get help": "Zatraži pomoć",
    "Get in touch for help": "Stupi u kontakt sa osobljem",
    "Get notified when someone replies to your comment": "Primi obavijest kad neko odgovori na moj komentar",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Ostavi feedback na ovaj članak",
    "Help! I'm not receiving emails": "Pomoć! Ne primam Email poruke",
    "Here are a few other sites you may enjoy.": "Evo nekoliko drugih stranica koje bi mogle biti od koristi.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Ako je newsletter označen kao spam, slanje Email poruka se automatski deaktivira za tu adresu u svrhu zaštite od novih neželjenih poruka.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Ako je pritužba na spam bila slučajna, ili želiš ponovno početi primati Email poruke, možeš se ponovno pretplatiti klikom na dugme na prethodnoj stranici.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Ako otkažeš pretplatu, nastavit ćeš imati pristup do {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Ako imaš korporativni ili vladin Email, obrati se svom IT kadru i zamoli ih da dopuste primanje Email poruka s adrese {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Link za prijavu poslan je na tvoju Email adresu. Ako ne stigne u roku od 3 minute, provjeri spam folder.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Ako želiš ponovo početi primati Email poruke, provjeri svoju Email adresu na bilo kakve probleme, a zatim se ponovo pretplati na prethodnoj stranici.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Ako ne primaš Email poruke od željenog newslettera, evo nekoliko stvari koje možeš provjeriti sada.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Ako i nakon gore navedenih provjera ne dobijaš Email poruke za željeni newsletter, kontaktiraj podršku: {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "U slučaju da se greške prilikom slanja nastave, Email poruke će se onemogućiti na nivou računa.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Dodaj {senderEmail} u kontakte. To vašem pružatelju usluga e-pošte daje do znanja da je pošta sa te adrese sigurna.",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "Manje sličnog sadržaja",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Provjeri jesu li se Email poruke slučajno završile u spam folderu ili promocijama vašeg poštanskog sandučića. Ako jesu, označite ih kao sigurne i/ili ih premjestite u glavni sandučić.",
    "Manage": "Upravljaj",
    "Maybe later": "Možda kasnije",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Članstvo nije dostupno, kontaktiraj vlasnika za pristup.",
    "month": "",
    "Monthly": "Mjesečno",
    "More like this": "Više poput ovoga",
    "More options": "",
    "Name": "Ime",
    "Need more help? Contact support": "Treba ti dodatna pomoć? Kontaktiraj podršku",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Newletteri na vašem računu se mogu onemogućiti iz dva razloga: Prethodni Email označena je kao spam ili pokušaj slanja Email poruke rezultirao je greškom (došlo je do odbacivanja nakon više neuspjelih pokušaja).",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Ne primaš Email poruke?",
    "Now": "",
    "Now check your email!": "Provjeri svoju Email adresu!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Nakon što se ponovno pretplatite, ako još uvijek ne vidiš Email u svom inboxu, provjeri spam folder. Neki pružatelji Email usluga čuvaju zapis prethodnih pritužbi na spam i nastavit će ih označavati kao takve. Ako se to dogodi, označite najnoviji newsletter Email kao \"Nije neželjena pošta\" da biste ga vratili u primarni inbox.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Trajna greška (odbacivanje nakon više neuspjelih pokušaja)",
    "Phone number": "",
    "Plan": "Plan",
    "Plan checkout was cancelled.": "Plaćanje plana je otkazano.",
    "Plan upgrade was cancelled.": "Ažuriranje plana je otkazano.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Kontaktiraj {supportAddress} za prilagođavanje besplatne pretplate.",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "Popuni obavezna polja",
    "Podcasts": "",
    "Re-enable emails": "Ponovno omogući Email poruke",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Preporuke",
    "Redeem your gift": "",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "Obnavlja se po cijeni od {price}.",
    "Resume subscription": "",
    "Retry": "Pokušaj ponovo",
    "Save": "Spremi",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Slanje linka za prijavu...",
    "Sending...": "Slanje...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Prikaži sve",
    "Sign in": "Prijavi se",
    "Sign out": "Odjavi se",
    "Sign up": "Registracija",
    "Signup error: Invalid link": "Greška pri prijavi: Neispravan link",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Žao nam je, to nije uspjelo.",
    "Spam complaints": "Pritužbe na spam",
    "Start {amount}-day free trial": "Započni {amount}-dnevni probni period",
    "Starting {startDate}": "Početak {startDate}",
    "Starting today": "Počinje danas",
    "Submit feedback": "Pošalji povratne informacije",
    "Subscribe": "Kreiraj račun",
    "Subscribed": "Pretplata uspješna",
    "Subscription plan updated successfully": "",
    "Success": "Uspjeh",
    "Success! Check your email for magic link to sign-in.": "Uspjeh! Provjeri svoju Email adresu za link za prijavu.",
    "Success! Your account is fully activated, you now have access to all content.": "Uspjeh! Tvoj je račun aktiviran, sada imaš pristup svim sadržajima.",
    "Success! Your email is updated.": "Uspjeh! Vaša Email adresa je promijenjena.",
    "Successfully unsubscribed": "Odjava uspješna",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Hvala na registraciji. Prije nego počneš čitati, u nastavku su slične stranice koje bi tebi mogle biti interesantne.",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "Hvala na povratnim informacijama!",
    "That didn't go to plan": "To nije pošlo prema planu",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Email adresa koju smo spasili za tebe je {memberEmail} — ako to nije tačno, možeš je promijeniti u <button>postavkama računa</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Došlo je do problema prilikom slanja tvojih povratnih informacija. Molimo pokušaj ponovo malo kasnije.",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Ova je stranica samo na poziv, kontaktiraj vlasnika za pristup.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Za nastavak procesa registracije, klikni na potvrdni link u svom inboxu. Ako ne stigne u roku od 3 minute, provjeri spam folder!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Isprobaj besplatno {amount} dana, a zatim plati {originalPrice}.",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Otključaj pristup svim newsletterima tako što ćete postati plaćeni član.",
    "Unsubscribe from all emails": "Odjava sa svih Email poruka",
    "Unsubscribed": "Odjavljeno",
    "Unsubscribed from all emails.": "Odjavljeno sa svih Email poruka.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Odjava s Email poruka neće otkazati tvoju plaćenu članarinu na {title}",
    "Update": "Ažuriraj",
    "Update your preferences": "Ažuriraj svoje postavke",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Link za potvrdu poslan, provjeri svoj inbox",
    "Verify your email address is correct": "Provjeri je li tvoja Email adresa ispravna",
    "Verifying...": "",
    "View plans": "Pregledaj planove",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Nismo te mogli odjaviti jer Email nije pronađen. Molimo kontaktiraj vlasnika web stranice.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Dobrodošli nazad, {name}!",
    "Welcome back!": "Dobrodošli nazad!",
    "Welcome to {siteTitle}": "Dobrodošli na {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Kada inbox ne prihvata Email poruke, to se obično naziva bounce (odbijanje). U mnogim slučajevima, to može biti privremeno. Međutim, u nekim slučajevima, odbijena e-pošta može biti vraćena kao trajni neuspjeh kada je Email adresa neispravna ili nepostojeća.",
    "Why has my email been disabled?": "Zašto mi je onemogućena Email adresa?",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "Godišnje",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Trenutno imaš besplatno članstvo, nadogradi na plaćenu članarinu za potpuni pristup.",
    "You have been successfully resubscribed": "Uspješno ste ponovo postali član",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Trenutno ne primate Email poruke",
    "You're not receiving emails": "Ne primam Email poruke",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Ne primaš Email poruke jer je posljednja poruka označena kao spam ili zato što poruke nisu mogle biti dostavljene na tvoj inbox iz bilo kojeg drugog razloga.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_few": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_few": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "Uspješna prijava.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Uspješna pretplata na <strong>{siteTitle}</strong>",
    "Your account": "Tvoj račun",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Tvoj feedback pomaže pri odabiru tema koje se objavljuju.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Tvoja pretplata istieče {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Tvoja pretplata će se obnoviti {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Tvoja pretplata će započeti {subscriptionStart}"
}
